import { useCallback, useState } from 'react'
import type { AppConfigMasked, UpdateAppConfigPayload } from 'types/app-config'
import type { MutationResult, QueryResult } from 'utils/api'

import { useApiQuery } from '../useApiQuery'
import { useFetchApi } from '../useFetchApi'

export function useAppConfig(): QueryResult<AppConfigMasked> {
  return useApiQuery<AppConfigMasked>('/api/app-config')
}

export function useUpdateAppConfig(): MutationResult<AppConfigMasked, [UpdateAppConfigPayload]> {
  const { fetchApi } = useFetchApi()
  const [loading, setLoading] = useState(false)
  const perform = useCallback(
    async (payload: UpdateAppConfigPayload): Promise<AppConfigMasked> => {
      setLoading(true)
      try {
        return await fetchApi<AppConfigMasked>('/api/app-config', {
          method: 'PUT',
          body: JSON.stringify(payload),
        })
      } finally {
        setLoading(false)
      }
    },
    [fetchApi],
  )
  return { perform, loading }
}

export function useDeleteAppConfig(): MutationResult<void, [string]> {
  const { fetchApi } = useFetchApi()
  const [loading, setLoading] = useState(false)
  const perform = useCallback(
    async (key: string): Promise<void> => {
      setLoading(true)
      try {
        await fetchApi(`/api/app-config/${key}`, { method: 'DELETE' })
      } finally {
        setLoading(false)
      }
    },
    [fetchApi],
  )
  return { perform, loading }
}
